import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../primitives/Checkbox/components/Checkmark/components/Container.js';
export const Checkmark = /*#__PURE__*/_styled(props => {
  const {
    invalid,
    size = 'medium',
    className,
    disabled,
    ...restProps
  } = props;
  return _jsxs(Container, {
    disabled: disabled,
    invalid: invalid,
    className: className,
    size: size,
    children: [_jsx("input", {
      ...restProps,
      type: "checkbox",
      disabled: disabled
    }), _jsx("svg", {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      children: _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.3 0C1 0 0 1 0 2.3v13.4C0 17 1 18 2.3 18h13.4c1.3 0 2.3-1 2.3-2.3V2.3C18 1 17 0 15.7 0H2.3Zm11 5.9a.9.9 0 1 0-1.5-1l-4 6.3-1.8-2a.9.9 0 0 0-1.2 1.3l2.6 2.7a.9.9 0 0 0 1.4-.1l4.6-7.2Z"
      })
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e6xjvy60"
} : {
  target: "e6xjvy60",
  label: "Checkmark"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1HIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvQ2hlY2tib3gvY29tcG9uZW50cy9DaGVja21hcmsvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuZXhwb3J0IGNvbnN0IENoZWNrbWFyayA9IHN0eWxlZCgocHJvcHMpID0+IHtcbiAgICBjb25zdCB7IGludmFsaWQsIHNpemUgPSAnbWVkaXVtJywgY2xhc3NOYW1lLCBkaXNhYmxlZCwgLi4ucmVzdFByb3BzIH0gPSBwcm9wcztcbiAgICByZXR1cm4gKF9qc3hzKENvbnRhaW5lciwgeyBkaXNhYmxlZDogZGlzYWJsZWQsIGludmFsaWQ6IGludmFsaWQsIGNsYXNzTmFtZTogY2xhc3NOYW1lLCBzaXplOiBzaXplLCBjaGlsZHJlbjogW19qc3goXCJpbnB1dFwiLCB7IC4uLnJlc3RQcm9wcywgdHlwZTogXCJjaGVja2JveFwiLCBkaXNhYmxlZDogZGlzYWJsZWQgfSksIF9qc3goXCJzdmdcIiwgeyB3aWR0aDogXCIxOFwiLCBoZWlnaHQ6IFwiMThcIiwgdmlld0JveDogXCIwIDAgMTggMThcIiwgeG1sbnM6IFwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIiwgY2hpbGRyZW46IF9qc3goXCJwYXRoXCIsIHsgZmlsbDogXCJjdXJyZW50Q29sb3JcIiwgZmlsbFJ1bGU6IFwiZXZlbm9kZFwiLCBjbGlwUnVsZTogXCJldmVub2RkXCIsIGQ6IFwiTTIuMyAwQzEgMCAwIDEgMCAyLjN2MTMuNEMwIDE3IDEgMTggMi4zIDE4aDEzLjRjMS4zIDAgMi4zLTEgMi4zLTIuM1YyLjNDMTggMSAxNyAwIDE1LjcgMEgyLjNabTExIDUuOWEuOS45IDAgMSAwLTEuNS0xbC00IDYuMy0xLjgtMmEuOS45IDAgMCAwLTEuMiAxLjNsMi42IDIuN2EuOS45IDAgMCAwIDEuNC0uMWw0LjYtNy4yWlwiIH0pIH0pXSB9KSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */");